// Kan er in deze browser een ingelogde gebruiker zijn? Beantwoordt dat zonder de Auth-SDK te laden.
//
// Waarom (MOW-PERF-OKT26, bundelslanking): de Auth-SDK is ±130 KB geparseerd. Vrijwel alle bezoekers
// hebben nooit ingelogd; voor hen is op een gewone winkelpagina niets te doen met de SDK. Firebase Auth
// bewaart een ingelogde gebruiker in de browser (volgorde uit lib/firebase-auth.ts: IndexedDB,
// localStorage, sessionStorage). Staat daar niets van, dan is er zeker niemand ingelogd.
//
// Het resultaat is een UITSLUITING, nooit een bewijs: `true` betekent "kan", `false` "zeker niet".
// Bij elke twijfel (oude browser zonder indexedDB.databases(), een fout, geblokkeerde opslag)
// wordt `true` teruggegeven, zodat de SDK dan gewoon laadt zoals voorheen.
//
// Let op: zodra de SDK ooit is gestart (loginpagina, afrekenen) bestaat de IndexedDB-database
// `firebaseLocalStorageDb` ook zonder gebruiker. Voor die bezoekers is het antwoord dus `true`
// en laadt de SDK weer; dat is veilig en kost alleen de besparing.

const IDB_NAAM = "firebaseLocalStorageDb"; // DB_NAME in @firebase/auth (indexedDBLocalPersistence)
const SLEUTEL_VOORVOEGSEL = "firebase:authUser:"; // _persistenceKeyName("authUser", apiKey, appName)

function heeftSleutel(opslag: Storage): boolean {
  for (let i = 0; i < opslag.length; i++) {
    if (opslag.key(i)?.startsWith(SLEUTEL_VOORVOEGSEL)) return true;
  }
  return false;
}

export async function mogelijkIngelogd(): Promise<boolean> {
  try {
    if (heeftSleutel(window.localStorage) || heeftSleutel(window.sessionStorage)) return true;
    if (!("indexedDB" in window) || !window.indexedDB) return false;
    const idb = window.indexedDB as IDBFactory & { databases?: () => Promise<{ name?: string }[]> };
    // Zonder databases() (Firefox < 126, oudere Safari) is niet te zien of de database bestaat. Een
    // indexedDB.open() om dat te proberen zou de database aanmaken zonder de objectstore die Firebase
    // verwacht, en daarmee Auth kapotmaken: dus niet doen, maar voor de zekerheid laden.
    if (typeof idb.databases !== "function") return true;
    const lijst = await idb.databases();
    return lijst.some((d) => d.name === IDB_NAAM);
  } catch {
    return true;
  }
}
